'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { icons } from '@peerless/ui-assets/icons';

import { useCurrentLocale } from '@peerless/ui-locale';
import { isCartEnabled } from '@peerless/data-access/cart-service';
import { useCart } from '../cart';

export const CartButton = () => {
  const { toggleIsOpen } = useCart();

  const locale = useCurrentLocale();
  if (!isCartEnabled(locale)) {
    return null;
  }

  return (
    <Button variant={'outlined'} color={'secondary'} onClick={() => toggleIsOpen()}>
      <FontAwesomeIcon icon={icons.cart} />
    </Button>
  );
};
